import React from 'react';
import * as BuilderUI from '../../../../../../../components/Builder/BuilderUI';
import { ICohortFieldsFragment } from '../../../../../../../utils/apollo/graphqlSchema';
import RemoveVariantAction from '../../SignificanceVariants/RemoveVariantAction';
import SignificanceSegmentCriteriaField from '../SignificanceSegmentCriteriaField';
import { useAppSelector } from '../../../../../../../redux/hooks';
import { significanceErrorSelector } from '../../../../../../../redux/selectors/builder';
import VariantLabel from '../../SignificanceVariants/VariantLabel';
import DndDroppableZone from '../../../../../../../components/DndEntity/DndDroppableZone';
import { EntityDropzoneType } from '../../../../../../../components/QuickAccessDictionary/DictionaryTabs/types';
import {
  EntityDropzoneDataTypeEnum,
  ISignificanceDropzoneDataType,
} from '../../../../../../../components/DndEntity/validation';

interface IProps {
  cohort: ICohortFieldsFragment | null;
  onChange: (
    cohort: ICohortFieldsFragment | null,
    variantIndex: number,
  ) => void;
  onRemove: (variantIndex: number) => void;
  variantIndex: number;
  allowRemove: boolean;
}

const SignificanceSegmentVariant = ({
  onChange,
  onRemove,
  cohort,
  variantIndex,
  allowRemove,
}: IProps) => {
  const hasError = useAppSelector((state) =>
    significanceErrorSelector(state, 'criteriaVariant'),
  );

  const dropzoneId = `Significance-Variant-Named-Cohort-Dropzone-${variantIndex}`;

  return (
    <BuilderUI.BuilderFieldContainer>
      <VariantLabel variantIndex={variantIndex} />
      <DndDroppableZone
        accepts={[EntityDropzoneType.Cohorts]}
        id={dropzoneId}
        data={
          {
            id: dropzoneId,
            type: EntityDropzoneDataTypeEnum.Significance,
            variantIndex,
          } satisfies ISignificanceDropzoneDataType
        }
        customMessage={`+ Add Cohort as Variant ${
          variantIndex === 0 ? 'A' : 'B'
        }`}
      >
        <SignificanceSegmentCriteriaField
          value={cohort}
          placeholder={'Select a named cohort as variant'}
          onChange={(namedCohort) => onChange(namedCohort, variantIndex)}
          hasError={variantIndex === 0 && hasError}
        />
      </DndDroppableZone>

      {allowRemove && (
        <RemoveVariantAction onClick={() => onRemove(variantIndex)} />
      )}
    </BuilderUI.BuilderFieldContainer>
  );
};

export default SignificanceSegmentVariant;
